module.exports = __webpack_public_path__ + "img/mercado.2cf39836.png";